// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","table":"_2pIrMwgWHM7Jid8ktgcELA","responsiveTable":"_3JB7VW60bRyBZ-30a2hJXm","check":"_3znXyagLwLTmoO7oD4coPJ"};